import Consts from 'Framework/Consts';
import { HttpGetService, IHttpGetServiceProps } from 'Shared/HttpServices/Services/HttpGetService';
import { HttpPostService, IHttpPostServiceProps } from 'Shared/HttpServices/Services/HttpPostService';
import { createAxiosHttpConfig } from 'Shared/HttpServices/Utils/utils';

const HavadesEnferadiHttpConfig = createAxiosHttpConfig({
  baseURL: Consts.env.REACT_APP_HADESEH_ENFERADI_APP_BASE_URL,
});

export const HavadesEnferadiHttpGetService = async (props: IHttpGetServiceProps) =>
  HttpGetService({
    API: HavadesEnferadiHttpConfig,
    url: props.url,
    responseType: props.responseType,
    onResult: props.onResult,
    onError: props.onError,
    isFile: props.isFile,
    params: props.params,
  });

export const HavadesEnferadiHttpPostService = async (props: IHttpPostServiceProps) =>
  HttpPostService({
    API: HavadesEnferadiHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });
